import React from 'react';
import { useTranslation } from 'react-i18next';

const Step2CategoryLocation = ({
  formData = {},
  onChange = () => {},
  categoryOptions = [],
  typeOptions = [],
  errors = {},
}) => {
  const { t } = useTranslation();

  const baseInputClass =
    'w-full p-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-primaryAccent transition-colors duration-200 text-gray-800 dark:text-gray-100 bg-white dark:bg-gray-800';

  const getBorderClass = (hasError) =>
    hasError ? 'border-red-500' : 'border-gray-300 dark:border-gray-600';

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100">
        {t('partnerJoin.step2.title')}
      </h2>

      {/* Kategori */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step2.category')} <span className="text-red-500">*</span>
        </label>
        <select
          name="category"
          value={formData.category || ''}
          onChange={onChange}
          className={`${baseInputClass} ${getBorderClass(errors.category)}`}
        >
          <option value="">{t('partnerJoin.step2.selectCategory')}</option>
          {categoryOptions.map((cat) => (
            <option key={cat.code || cat} value={cat.code || cat}>
              {cat.label || cat}
            </option>
          ))}
        </select>
        {errors.category && (
          <p className="text-sm text-red-500 mt-1">{errors.category}</p>
        )}
      </div>

      {/* Tipe */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step2.type')} <span className="text-red-500">*</span>
        </label>
        <select
          name="type"
          value={formData.type || ''}
          onChange={onChange}
          className={`${baseInputClass} ${getBorderClass(errors.type)}`}
        >
          <option value="">{t('partnerJoin.step2.selectType')}</option>
          {typeOptions.map((type) => (
            <option key={type.code || type} value={type.code || type}>
              {type.label || type}
            </option>
          ))}
        </select>
        {errors.type && (
          <p className="text-sm text-red-500 mt-1">{errors.type}</p>
        )}
      </div>

      {/* Alamat */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step2.address')} <span className="text-red-500">*</span>
        </label>
        <textarea
          name="address"
          rows={3}
          value={formData.address || ''}
          onChange={onChange}
          className={`${baseInputClass} ${getBorderClass(errors.address)}`}
        />
        {errors.address && (
          <p className="text-sm text-red-500 mt-1">{errors.address}</p>
        )}
      </div>

      {/* Wilayah */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step2.region')}
        </label>
        <input
          type="text"
          name="region"
          value={formData.region || ''}
          onChange={onChange}
          className={`${baseInputClass} ${getBorderClass(false)}`}
        />
      </div>

      {/* Latitude & Longitude */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
            {t('partnerJoin.step2.latitude')}
          </label>
          <input
            type="number"
            name="latitude"
            value={formData.latitude || ''}
            onChange={onChange}
            className={`${baseInputClass} ${getBorderClass(false)}`}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
            {t('partnerJoin.step2.longitude')}
          </label>
          <input
            type="number"
            name="longitude"
            value={formData.longitude || ''}
            onChange={onChange}
            className={`${baseInputClass} ${getBorderClass(false)}`}
          />
        </div>
      </div>
    </div>
  );
};

export default Step2CategoryLocation;
